/* eslint-disable import/prefer-default-export */

import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import {
  CODEBOOK_FILE_NAME,
  CODEBOOK_FILE_PATH,
  DATA_FILE_NAME,
  DATA_FILE_PATH,
  LEGEND_FILE_NAME,
  LEGEND_YEAR_FILE_NAME,
  VARIABLE_LIST,
} from 'constant'
import { BarChartGlobalData, BarChartNationalData, Country, MetricGroup, MetricValue, SortOrder, ViewType } from 'types'
import {
  createCountryData,
  createLegendData,
  createLegendYearData,
  createMetricData,
  createMetricDataTypeMap,
} from 'utils'
import { SubIndexCodes, VibrancyState } from './reducerSlice'

export const setCurrentYear =
  createAction<VibrancyState['configuration']['yearFilter']['currentYear']>('vibrancy/setCurrentYear')

export const loadCountryData = createAsyncThunk<Country[]>('vibrancy/loadCountryData', async (_, thunkAPI) => {
  try {
    const data = await createCountryData(`${DATA_FILE_PATH}${DATA_FILE_NAME}.csv`)
    return data
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})

export const loadMetricData = createAsyncThunk<MetricGroup[]>('vibrancy/loadMetricData', async (_, thunkAPI) => {
  try {
    const metricData = await createMetricData(`${CODEBOOK_FILE_PATH}${CODEBOOK_FILE_NAME}.csv`)
    return metricData
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})
export const loadLegendData = createAsyncThunk('vibrancy/loadLegendData', async (_, thunkAPI) => {
  try {
    const legendData = await createLegendData(`${DATA_FILE_PATH}${LEGEND_FILE_NAME}.csv`)
    return legendData
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})
export const loadLegendYearData = createAsyncThunk('vibrancy/loadLegendYearData', async (_, thunkAPI) => {
  try {
    const legendData = await createLegendYearData(`${DATA_FILE_PATH}${LEGEND_YEAR_FILE_NAME}.csv`)
    return legendData
  } catch (error) {
    return thunkAPI.rejectWithValue(error)
  }
})

export const loadMetricDataTypeMap = createAsyncThunk<Record<string, string>>(
  'vibrancy/loadMetricDataTypeMap',
  async (_, thunkAPI) => {
    try {
      const metricDataTypeMap = await createMetricDataTypeMap(`${CODEBOOK_FILE_PATH}${VARIABLE_LIST}.csv`)
      return metricDataTypeMap
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const setMultiplierMetricGroup = createAction<{ metricGroupName: string; value: number }>(
  'vibrancy/setMultiplierMetricGroup',
)

export const setMultiplierMetric = createAction<{ metricGroupName: string; metricName: string; value: number }>(
  'vibrancy/setMultiplierMetric',
)

export const setMetricValue = createAction<MetricValue>('vibrancy/setMetricValue')
export const setViewType = createAction<ViewType>('vibrancy/setViewType')
export const setGrouping = createAction<string>('vibrancy/setGrouping')
export const setSortOrder = createAction<SortOrder>('vibrancy/setSortOrder')
export const setBarChartGlobalData = createAction<BarChartGlobalData>('vibrancy/setBarChartGlobalData')
export const setBarChartNationalData = createAction<BarChartNationalData>('vibrancy/setBarChartNationalData')
export const resetAll = createAction('vibrancy/resetAll')
export const checkMetrices = createAction('vibrancy/checkMetrices')
export const equalize = createAction('vibrancy/equalize')
export const setShowDwnLoader = createAction<boolean>('vibrancy/setShowDwnLoader')
export const setShowChartLoader = createAction<boolean>('vibrancy/setShowChartLoader')
export const setSubIndex = createAction<SubIndexCodes>('vibrancy/setSubIndex')
